import { CUSTOMER_ACTION, RESET_ACTION } from '../staticData';

export function customerReducer(state: any, action: any) {
  switch (action.type) {
    case CUSTOMER_ACTION.set:
      return { ...state, ...action.payload };

    case RESET_ACTION:
      return {};

    default:
      throw new Error();
  }
}
